export const IconMail = ({ className }: { className?: string }) => (
  <svg width="64" height="64" viewBox="0 0 64 64" className={`fill-current ${className}`} xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M50.6667 10.6667H13.3333H13.3333C8.91507 10.6667 5.33333 14.2485 5.33333 18.6667V45.3334C5.33333 49.7517 8.91507 53.3334 13.3333 53.3334H50.6667C55.0849 53.3334 58.6667 49.7517 58.6667 45.3334V18.6667C58.6667 14.2485 55.0849 10.6667 50.6667 10.6667V10.6667ZM48.885 16.0001L32.005 28.6667L15.125 16.0001H48.885ZM50.6667 48.0001H13.3333C11.8606 48.0001 10.6667 46.8062 10.6667 45.3334V19.3334L30.4 34.1334C30.8616 34.4796 31.423 34.6667 32 34.6667C32.577 34.6667 33.1384 34.4796 33.6 34.1334L53.3333 19.3334V45.3334C53.3333 46.8062 52.1394 48.0001 50.6667 48.0001Z"
    />
  </svg>
)
